import React, { useState, useContext, useEffect } from 'react'

import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { toast } from 'react-toastify';

import InputSearch from '~/components/Input/InputSearch';
import Paper from '~/components/Paper'
import GridContainer from '~/components/GridContainer'
import GridItem from '~/components/GridItem'
import Button from '~/components/Button';
import LinearProgress from '~/components/LinearProgress';

import InputControl from '~/components/Input/InputControl'
import InputDate from '~/components/Input/InputDate'
import InputSwitch from '~/components/Input/InputSwitch'

import Table from '~/components/Table/Table';
import TablePagination from '~/components/Table/TablePagination';
import tableStyles from '~/components/Table/Table/styles';

import BookIcon from '@material-ui/icons/Book';
import SaveAlt from '@material-ui/icons/SaveAlt';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import isBlank from '~/utils/isBlank';
import csvGenerator from '~/utils/csvGenerator';
import xlsxGenerator from '~/utils/xlsxGenerator';
import isPresent from '~/utils/isPresent';
import toInt from '~/utils/Number/toInt';

import Request from '~/providers/Request';

import CurrentUser from '~/contexts/CurrentUser';
import { showLog } from '~/config/routes';

import Chip from '@material-ui/core/Chip';
import Link from '@material-ui/core/Link';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

function LogsReports() {
  const { t } = useTranslation()
  const { user } = useContext(CurrentUser);
  const classesTable = tableStyles();

  const [loading, setLoading] = useState(false);
  const [logsData, setLogsData] = useState([]);
  const [totalLogsData, setTotalLogsData] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [inputSearch, setInputSearch] = useState('');


  const [dataInit, setDataInit] = useState(moment().startOf('month').format())
  const [dataEnd, setDataEnd] = useState(moment().endOf('month').format())
  const [considerAtendent, setConsiderAtendent] = useState(true)
  const [considerDocumentStatus, setConsiderDocumentStatus] = useState(true)
  const [considerDoctor, setConsiderDoctor] = useState(true)
  const [considerMarketing, setConsiderMarketing] = useState(true)
  const [considerAdmin, setConsiderAdmin] = useState(true)
  const [considerInsertion, setConsiderInsertion] = useState(true)
  const [considerUpdate, setConsiderUpdate] = useState(true)
  const [considerDelete, setConsiderDelete] = useState(true)

  const trAttr = (attr) => t(`logsReports.attributes.${attr}`);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  function onExport(type) {
    const filters = {
      start: dataInit,
      end: dataEnd,
      page: 1,
      per_page: 50000,
      considerAtendent,
      considerDoctor,
      considerMarketing,
      considerAdmin,
      considerInsertion,
      considerUpdate,
      considerDelete,
      considerDocumentStatus
    };
    toast.info(`Arquivo ${type.toLocaleUpperCase()} esta sendo gerado!`);
    generateFile(filters, type);
  }

  async function generateFile(filters, type) {
    try {
      const registers = await Request.get(
        '/admin/report/logs',
        filters,
        {
          normalizeJSON: false,
        }
      );

      const rows = [];

      let filtersStr = ''
      if (filters.considerAtendent) filtersStr += 'Atendente, ';
      if (filters.considerDoctor) filtersStr += 'Médico, ';
      if (filters.considerMarketing) filtersStr += 'Marketing, ';
      if (filters.considerAdmin) filtersStr += 'Administrador, ';
      if (filters.considerInsertion) filtersStr += 'Inserção, ';
      if (filters.considerUpdate) filtersStr += 'Atualização, ';
      if (filters.considerDelete) filtersStr += 'Exclusão, ';
      if (filters.considerDocumentStatus) filtersStr += 'Status de documentos, ';

      rows.push(['Filtros']);
      rows.push(['Usuários', filtersStr]);
      rows.push(['']);

      rows.push(['Período', `${moment(filters.start).format('DD/MM/YYYY HH:mm')} a ${moment(filters.end).format('DD/MM/YYYY HH:mm')}`]);

      rows.push(['']);
      rows.push(['Data', 'Usuário', 'Ação', 'Código', 'Nome']);
      registers.data.map((item) => {
        rows.push([
          moment(item.timestamp).format('DD/MM/YYYY HH:mm:ss'),
          item.user,
          item.message,
          item.id,
          item.name,
        ]);
        return item;
      });

      rows.push(['']);
      rows.push(['Relatório gerado por', user.name]);
      rows.push(['Relatório gerado em', `${moment().format('L')} - ${moment().format('LT')}`]);

      if (type === 'csv') csvGenerator(`relatorio_de_logs.csv`, [...rows]);
      else xlsxGenerator(`relatorio_de_logs.xlsx`, [...rows]);

      toast.success(`Arquivo ${type.toLocaleUpperCase()} de logs gerado com sucesso!`);

      const totalPages =
        toInt(registers.meta.total) / registers.meta.perPage;
      if (registers.meta.page < totalPages) {
        filters.page += 1;
        generateFile(filters, type);
      }
    } catch (error) {
      console.log(error);
      toast.error(
        `Não foi possível gerar o arquivo ${type.toLocaleUpperCase()} de logs`
      );
    }
  }

  async function getLogsData() {
    setLoading(true);

    const filters = {
      start: dataInit,
      end: dataEnd,
      page: page + 1,
      per_page: rowsPerPage,
      considerAtendent,
      considerDoctor,
      considerMarketing,
      considerAdmin,
      considerInsertion,
      considerUpdate,
      considerDelete,
      considerDocumentStatus,
      qs: inputSearch,
    };

    try {
      const registers = await Request.get(
        '/admin/report/logs',
        filters,
        {normalizeJSON: false}
      );

      setTotalLogsData(toInt(registers.meta.total));
      setLogsData(registers.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function fetchParams() {
    const url = new URLSearchParams(window.location.search);

    const start = url.get('start');
    const end = url.get('end');

    if (isPresent(start)) {
      const startDate = moment(start);

      if (startDate.isValid()) {
        setDataInit(startDate.format());
      }
    }
    if (isPresent(end)) {
      const endDate = moment(end);

      if (endDate.isValid()) {
        setDataEnd(endDate.format());
      }
    }
  }

  useEffect(() => {
    if (!considerInsertion && !considerUpdate && !considerDelete && !considerDocumentStatus) return;

    if (dataInit && dataEnd) {
      getLogsData();
    }
  }, [
    dataInit,
    dataEnd,
    page,
    rowsPerPage,
    considerAtendent,
    considerDoctor,
    considerMarketing,
    considerAdmin,
    considerInsertion,
    considerUpdate,
    considerDelete,
    considerDocumentStatus,
    inputSearch
  ]);

  useEffect(() => {
    fetchParams();
  }, []);

  const setStates = [
    setConsiderInsertion,
    setConsiderUpdate,
    setConsiderDelete,
    setConsiderDocumentStatus
  ];
  const states = [
    considerInsertion,
    considerUpdate,
    considerDelete,
    considerDocumentStatus
  ];

  const handleChangeSwitch = (e, setState) => {
    if (
        setStates.includes(setState)
        && !e
        && states.filter((state) => state === true).length === 1
      ) {
        toast.error('Necessário selecionar ao menos um filtro!');
        setTimeout(() => {
          setState(true);
        }, 200);
      }
    setState(e);
  };

  return (
    <>
      <Paper
        Icon={BookIcon}
        iconColor='blue'
        title={t('dashboard.attributes.logs_reports')}
      >
        <GridContainer>
          <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
            <InputControl
              value={dataInit}
              name='date'
              label={t('logsReports.extras.date_init')}
              inputComponent={InputDate}
              InputProps={{
                type: 'date'
              }}
              onChange={(date) => {
                setDataInit(moment(date).startOf('day').format())
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
            <InputControl
              value={dataEnd}
              name='date'
              label={t('logsReports.extras.date_end')}
              inputComponent={InputDate}
              InputProps={{
                type: 'date'
              }}
              onChange={(date) => {
                setDataEnd(moment(date).endOf('day').format())
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
            <InputSwitch
              label={t('logsReports.extras.considerInsertion')}
              value={considerInsertion}
              onChange={(e) => handleChangeSwitch(e, setConsiderInsertion)}
            />
            <InputSwitch
              label={t('logsReports.extras.considerUpdate')}
              value={considerUpdate}
              onChange={(e) => handleChangeSwitch(e, setConsiderUpdate)}
            />
            <InputSwitch
              label={t('logsReports.extras.considerDelete')}
              value={considerDelete}
              onChange={(e) => handleChangeSwitch(e, setConsiderDelete)}
            />
            <InputSwitch
              label={t('logsReports.extras.considerDocumentStatus')}
              value={considerDocumentStatus}
              onChange={(e) => handleChangeSwitch(e, setConsiderDocumentStatus)}
            />
          </GridItem>
          <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
            <InputSwitch
              label={t('logsReports.extras.considerAtendent')}
              value={considerAtendent}
              onChange={setConsiderAtendent}
            />
            <InputSwitch
              label={t('logsReports.extras.considerDoctor')}
              value={considerDoctor}
              onChange={setConsiderDoctor}
            />
            <InputSwitch
              label={t('logsReports.extras.considerMarketing')}
              value={considerMarketing}
              onChange={setConsiderMarketing}
            />
            <InputSwitch
              label={t('logsReports.extras.considerAdmin')}
              value={considerAdmin}
              onChange={setConsiderAdmin}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputSearch
              value={inputSearch}
              label={t('logsReports.extras.search')}
              placeholder={t('userActives.extras.search')}
              onChange={setInputSearch}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem align="right">
            <Button
              color="second"
              onClick={() => {
                onExport('csv');
              }}
            >
              {t('action.export_csv')} <SaveAlt />
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              color="orange"
              onClick={() => {
                onExport('xlsx');
              }}
            >
              {t('action.export_xlsx')} <SaveAlt />
            </Button>
          </GridItem>
        </GridContainer>

        <LinearProgress loading={loading} />

        <Table
          emptyData={logsData.length === 0}
          loading={loading}
          columns={
            <>
            <TableCell className={classesTable.cell}>
                {trAttr('id')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('date')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('action')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('owner')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('key')}
              </TableCell>
            </>
          }
        >
          {logsData.map((item) => {
            console.log(showLog.reverse({
              id: item.logId,
            }))
            console.log('a')
          return (
          <TableRow key={`${item.id}-${item.action}-${item.timestamp}`} hover className={classesTable.row}>
            <TableCell>
              <Chip
                    label={item.logId}
                    component={Link}
                    href={showLog.reverse({
                      id: item.logId,
                    })}
                    style={{ cursor: 'pointer' }}
                    target="_blank"
                    color="primary"
                    variant="outlined"
                    onDelete={() => {}}
                    deleteIcon={<OpenInNewIcon />}
                  />
              </TableCell>
              <TableCell>{moment(item.timestamp).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
              <TableCell>{item.message}</TableCell>
              <TableCell>{item.owner}</TableCell>
              <TableCell>{item.key}</TableCell>
            </TableRow>
          )
        }
          )}
        </Table>

        <LinearProgress loading={loading} />

        <Typography
          variant="subtitle2"
          color="primary"
          align="right"
          style={{ paddingRight: 16, marginTop: 10 }}
        >
          <strong>Total: </strong>
          {totalLogsData}
        </Typography>

        <TablePagination
          count={totalLogsData}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </>

  )
}

export default LogsReports
